module.exports = __webpack_public_path__ + "static/img/beti.b123e9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/beti.png
// module id = K2cD
// module chunks = 1